<template>

  <main class="min-h-screen w-full bg-gray-100 p-4">

    <div class="w-full max-w-full space-y-4">

      <!-- PAGE HEADER -->
      <div class="sticky top-0 z-20 flex items-center justify-between mb-3 bg-gray-100 py-3">

        <h1 class="text-2xl font-semibold text-gray-800">
          Notice Updates Posts
        </h1>

        <button @click="openCreateModal"
          class="bg-orange-500 text-white font-medium px-3 py-1.5 rounded hover:bg-orange-600 transition">
          + Create Post
        </button>

      </div>

      <!-- POSTS LIST (separate component) -->
      <PostLists :posts="passSectionItemPost" @edit="openEditModal" media-width="15%" media-height="15%" />

    </div>

    <!-- CREATE / EDIT POST MODAL -->
    <CreatePostModal :show="showModal" :postToEdit="postBeingEdited" @close="closeModal" @refresh="handlePostRefresh" />

  </main>
</template>

<script>
import { ref } from "vue";

import PostLists from "./Posts/PostLists.vue";
import CreatePostModal from "./Modals/CreatePostModal.vue";

export default {
  components: {
    PostLists,
    CreatePostModal,
  },
  props: {
    passSectionItemPost: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const showModal = ref(false);
    const postBeingEdited = ref(null);

    const openCreateModal = () => {
      postBeingEdited.value = null;
      showModal.value = true;
    };

    const openEditModal = (post) => {
      postBeingEdited.value = post;
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      postBeingEdited.value = null;
    };

    return {
      showModal,
      postBeingEdited,
      openCreateModal,
      openEditModal,
      closeModal,
    };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
